import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MapView = ({ spots, onSpotClick, selectedSpot }) => {
  const [mapCenter] = useState({ lat: 39.0, lng: 35.0 });
  const [zoom] = useState(6);

  const handleMarkerClick = (spot) => {
    onSpotClick(spot);
  };

  return (
    <div className="relative w-full h-full bg-muted rounded-xl overflow-hidden">
      <iframe
        width="100%"
        height="100%"
        loading="lazy"
        title="Türkiye SUP Spotları Haritası"
        referrerPolicy="no-referrer-when-downgrade"
        src={`https://www.google.com/maps?q=${mapCenter?.lat},${mapCenter?.lng}&z=${zoom}&output=embed`}
        className="w-full h-full"
      />
      <div className="absolute top-4 left-4 right-4 flex flex-col gap-2">
        <div className="bg-card/95 backdrop-blur-sm rounded-lg shadow-organic p-3">
          <div className="flex items-center gap-2 text-sm text-foreground">
            <Icon name="MapPin" size={16} className="text-primary" />
            <span className="font-medium">{spots?.length} spot bulundu</span>
          </div>
        </div>

        {selectedSpot && (
          <div className="bg-card/95 backdrop-blur-sm rounded-lg shadow-organic p-4">
            <div className="flex items-start justify-between gap-3 mb-2">
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-semibold text-foreground mb-1 line-clamp-1">
                  {selectedSpot?.name}
                </h3>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Icon name="MapPin" size={12} />
                  <span className="line-clamp-1">{selectedSpot?.location}</span>
                </div>
              </div>
              <Button
                variant="ghost"
                size="icon"
                iconName="X"
                onClick={() => onSpotClick(null)}
              />
            </div>
            <div className="flex items-center gap-3 text-xs">
              <div className="flex items-center gap-1">
                <Icon name="Star" size={12} className="text-yellow-500 fill-yellow-500" />
                <span className="font-medium">{selectedSpot?.rating}</span>
              </div>
              <div className="flex items-center gap-1">
                <Icon name="Users" size={12} />
                <span>{selectedSpot?.recentVisitors} ziyaret</span>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="absolute bottom-4 right-4 flex flex-col gap-2">
        <Button
          variant="secondary"
          size="icon"
          iconName="Plus"
          className="shadow-organic"
        />
        <Button
          variant="secondary"
          size="icon"
          iconName="Minus"
          className="shadow-organic"
        />
        <Button
          variant="secondary"
          size="icon"
          iconName="Locate"
          className="shadow-organic"
        />
      </div>
      <div className="absolute bottom-4 left-4">
        <div className="bg-card/95 backdrop-blur-sm rounded-lg shadow-organic p-2 flex items-center gap-2">
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 rounded-full bg-green-500" />
            <span className="text-xs text-foreground">Başlangıç</span>
          </div>
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 rounded-full bg-yellow-500" />
            <span className="text-xs text-foreground">Orta</span>
          </div>
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 rounded-full bg-red-500" />
            <span className="text-xs text-foreground">İleri</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapView;